<template>
	<div>
        <v-flex xs7 ml-5 mt-4>
            <v-layout wrap>
				<v-flex xs12 mb-3>
					<v-layout row wrap align-center>
						<v-flex xs10>
							<p class="company-text-regular ma-0">
				    			Indicar si la empresa trabajara con conversion (intercambio de documento NTV -> BOL) (flagChangeNtvFlow)
							</p>
							</v-flex>
						<v-flex xs2 pl-2>
					        <v-layout row align-center>
								<v-flex>
									<app-tooltip-button
                                        color="primary"
										icon="help"
										text="Permitir intercambiar numeracion al convertir notas de venta(relacionadas a pedidos) a boleta/factura."
									></app-tooltip-button>
								</v-flex>
								<v-flex>
									<v-switch
										color="success"
										hide-details
										v-model="flagKardex.flagChangeNtvFlow"
									></v-switch>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
                <v-flex xs12 mb-3>
					<v-layout row wrap align-center>
						<v-flex xs10>
							<p class="company-text-regular ma-0">
				    			{{ labelShowKardex }} (flagKardexValued)
							</p>
							</v-flex>
						<v-flex xs2 pl-2>
					        <v-layout row align-center>
								<v-flex>
									<app-tooltip-button
                                        color="primary"
										icon="help"
										text="Si activo esta opción se usará el calculo de costo promedio si en caso lo desactivo
											el costo que se va a mostrar en tu producto maestro va hacer el último costo de tu compra."
									></app-tooltip-button>
								</v-flex>
								<v-flex>
									<v-switch
										color="success"
										hide-details
										v-model="flagKardex.flagKardexValued"
									></v-switch>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
                <v-flex xs12 mb-3>
					<v-layout row wrap align-center>
						<v-flex xs10>
							<p class="company-text-regular ma-0">
				    			Calculo de saldo de stock y costo inmediato (flagKardexFast)
							</p>
							</v-flex>
						<v-flex xs2 pl-2>
					        <v-layout row align-center>
								<v-flex>
									<app-tooltip-button
                                        color="primary"
										icon="help"
										text="Indica si el inmediatamente despues de registrar en el kardex estos registros se les calculará el stock y/o costo')."
									></app-tooltip-button>
								</v-flex>
								<v-flex>
									<v-switch
										color="success"
										hide-details
										v-model="flagKardex.flagKardexFast"
									></v-switch>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
                <v-flex xs12 mb-3>
					<v-layout row wrap align-center>
						<v-flex xs10>
							<p class="company-text-regular ma-0">
				    			{{ labelShowRegisterKardex }} (typeRegisterKardex)
							</p>
							</v-flex>
						<v-flex xs2 pl-2>
					        <v-layout row align-center>
								<v-flex>
									<app-tooltip-button
                                        color="primary"
										icon="help"
										text="Al habilitar este campo se genera un registro inmediato por DB, de lo contrario se registra por SQS."
									></app-tooltip-button>
								</v-flex>
								<v-flex>
								    <v-switch
										:disabled="true"
										:false-value="1"
										:true-value="2"
										color="success"
										hide-details
										v-model="flagKardex.typeRegisterKardex"
									></v-switch>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-flex>
            </v-layout>
		</v-flex>
	</div>
</template>
<script>

import appTooltipButton from '@/components/shared/app-tooltip-button';

function data() {
    return {
        flagKardex: null,
    };
}

function created() {
    this.flagKardex = this.data.items.data.settings;
}

export default {
    name: 'configuration-kardex',
    data,
    components: {
        appTooltipButton
    },
    created,
    computed: {
        labelShowKardex() {
            return this.flagKardex.flagKardexValued ? 'Utilizar costo promedio' :
                'Utilizar último costo';
        },
        labelShowRegisterKardex() {
            return this.typeRegisterKardex ? 'Registro inmediato por DB' : 'Registro por SQS';
        },
    },
    props: {
        data: {
            type: Object,
        },
    },
    watch: {
        flagKardex: {
            handler(newVal) {
                this.$emit('update:flagKardex', newVal, 'kardex');
            },
            deep: true
        }
    },
};

</script>


// WEBPACK FOOTER //
// src/components/configuration-general/configuration-kardex.vue